import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  postUpdateDSDData,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";
import { UploadAttachmentFile } from "../CreateInventoryAdjustment/interface";

export const editDSDCreditData = createAsyncThunk(
  "editDSDCreditData",
  (payload: any) => postUpdateDSDData(payload)
);

export const editDSDCreditUploadAttachments = createAsyncThunk(
  "editDSDCreditUploadAttachments",
  (dsdAttachmentPayload: UploadAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(dsdAttachmentPayload)
);

export const deleteDSDCreditAttachments = createAsyncThunk(
  "deleteDSDCreditAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

const initialState: any = {
  notes: "",
  attachments: [],
  blockNavigation: true,
  loading: false
};

const editDSDCreditSlice = createSlice({
  name: "editDSDCredit",
  initialState,
  reducers: {
    updateDSDCreditNavigationBlocking(state: any, action: any) {
      state.blockNavigation = action.payload;
    },
    updateDSDCreditNotes(state: any, action: any) {
      const notes = action.payload;
      state.notes = notes;
    },
    updateDSDCreditAttachment(
      state: any,
      action: {
        payload: { fileName: string; fileURL: string; fileType: string };
      }
    ) {
      state.attachments.push(action.payload);
    },
    removeDSDCreditAttachment(state: any, action: { payload: number }) {
      const filterAttachments = state.attachments.filter(
        (_item: any, itemIndex: number) => itemIndex !== action?.payload
      );
      state.attachments = filterAttachments;
    },
    resetDSDCreditData() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(editDSDCreditData.pending, (state) => {
        state.loading = true;
      })
      .addCase(editDSDCreditData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editDSDCreditData.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const {
  updateDSDCreditNotes,
  updateDSDCreditNavigationBlocking,
  updateDSDCreditAttachment,
  removeDSDCreditAttachment,
  resetDSDCreditData
} = editDSDCreditSlice.actions;

export const selectBlockDSDCreditNavigation = (state: any) =>
  state.editDSDCredit.blockNavigation;

export const selectDSDCreditNotes = (state: any) => state.editDSDCredit.notes;

export const selectDSDCreditAttachments = (state: any) =>
  state.editDSDCredit?.attachments;

export default editDSDCreditSlice.reducer;
